import React, { useState } from 'react';
import {
  Button,
  Grid,
  Stack,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import NotesDisplay from './NotesDisplay';
import { NotesDisplayColumn, NotesDisplayProps } from './NotesDisplay';

export type NotesDisplayWithAddProps = Omit<NotesDisplayProps, 'titleButton' | 'onAddNote'> & {
  titleButton?: string;
  onAddNote?: () => void;
  isAllowedToAdd?: boolean;
};

export default function NotesDisplayWithAdd({
  data,
  columns,
  titleButton,
  onAddNote,
  isAllowedToAdd = false,
  ...otherProps
}: NotesDisplayWithAddProps) {
  return (
    <>
      <Stack>
        <Grid
          container
          display={'flex'}
          alignItems={'center'}
          paddingRight={2}
        >
          {titleButton && isAllowedToAdd && (
            <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
              <Button 
                variant='contained'
                size="small"
                sx={{ height: '36px' }}
                startIcon={<Add />}
                style={{ position: 'absolute', top: '25px', right: '25px' }}
                onClick={onAddNote}
              >
                {titleButton}
              </Button>
            </Grid>
          )}
        </Grid>
      </Stack>
      <NotesDisplay
        data={data}
        columns={columns}
        {...otherProps}
      />
    </>
  );
}
